import Vuex from 'vuex'
import axios from 'axios'
import { uuid } from "vue-uuid";

export default new Vuex.Store({
    state: {
        accessToken: localStorage.getItem('accessToken') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        userData: localStorage.getItem('userData') || '',
        cityModules: localStorage.getItem('cityModules') || '',
        cities: localStorage.getItem('cities') || '',
    },
    mutations: {
        set_cities(state, data) {
            state.cities = data.respData
        },
        auth_success(state, data) {
            state.accessToken = data.respDataString
            state.refreshToken = data.postDataString
        },
        set_user_data(state, data) {
            state.userData = data.userData
        },
        set_city_modules(state, data) {
            state.cityModules = data.cityModules
        },
        logout(state) {
            state.accessToken = ''
            state.refreshToken = ''
            state.userData = ''
            state.cityModules = ''
            state.cities = ''
        },
    },
    actions: {
        login({ commit }, postData) {
            return new Promise((resolve, reject) => {

                axios({
                    method: 'POST',
                    url: process.env.VUE_APP_ENDPOINT_URL + 'oauth/token',
                    data: postData,
                    headers: {
                        'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                        'x-requestId': uuid.v4(),
                    }
                }).then(resp => {

                    const loginResp = resp.data

                    localStorage.setItem('accessToken', loginResp.access_token)
                    localStorage.setItem('refreshToken', loginResp.refresh_token)

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + loginResp.access_token

                    let respDataString = JSON.stringify(loginResp)
                    let postDataString = JSON.stringify(postData)

                    commit('auth_success', { respDataString, postDataString })
                    this.dispatch('communicate', {
                        'method': 'GET',
                        'url': 'api/userenv',
                        'axios_params': {}
                    }).then(userEnvResponse => {

                        if (userEnvResponse.status == 200) {
                            const userData = JSON.stringify(userEnvResponse.data.data[0])
                            commit('set_user_data', { userData })
                            localStorage.setItem('userData', userData)
                            // resolve(userEnvResponse)
                            this.dispatch('communicate', {
                                'method': 'GET',
                                'url': 'api/modules',
                                'axios_params': {}
                            }).then(modulesResponse => {

                                if (userEnvResponse.status == 200) {
                                    const cityModules = JSON.stringify(modulesResponse.data.data)
                                    commit('set_city_modules', { cityModules })
                                    localStorage.setItem('cityModules', cityModules)
                                    resolve(modulesResponse)
                                } else {
                                    reject(modulesResponse.data)
                                }
                            }).catch(error => {
                                reject(error.response)
                            })
                        } else {
                            reject(userEnvResponse.data)
                        }

                    }).catch(error => {
                        reject(error.response)
                    })

                }).catch(error => {
                    reject(error.response)
                })
            })
        },
        cityManagerLogin({ commit }, postData) {
            return new Promise((resolve, reject) => {

                axios({
                    method: 'POST',
                    url: process.env.VUE_APP_ENDPOINT_URL + 'oauth/token',
                    data: postData,
                    headers: {
                        'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                        'x-requestId': uuid.v4(),
                    }
                }).then(resp => {

                    const loginResp = resp.data

                    localStorage.setItem('accessToken', loginResp.access_token)
                    localStorage.setItem('refreshToken', loginResp.refresh_token)

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + loginResp.access_token

                    let respDataString = JSON.stringify(loginResp)
                    let postDataString = JSON.stringify(postData)

                    commit('auth_success', { respDataString, postDataString })
                    this.dispatch('communicate', {
                        'method': 'GET',
                        'url': 'api/userenv',
                        'axios_params': {}
                    }).then(userEnvResponse => {

                        if (userEnvResponse.status == 200) {

                            const userData = JSON.stringify(userEnvResponse.data.data[0])
                            commit('set_user_data', { userData })
                            localStorage.setItem('userData', userData)

                            resolve(userEnvResponse)
                        } else {
                            reject(userEnvResponse.data)
                        }

                    }).catch(error => {
                        reject(error.response)
                    })

                }).catch(error => {
                    reject(error.response)
                })
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')

                localStorage.removeItem('accessToken')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('userData')
                localStorage.removeItem('cityModules')
                localStorage.removeItem('cities')

                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        // eslint-disable-next-line no-unused-vars
        communicate({ commit }, params) {

            return new Promise((resolve, reject) => {
                switch (params.method) {
                    case 'GET':

                        axios.get(
                            process.env.VUE_APP_ENDPOINT_URL + params.url,
                            {
                                params: params.axios_params,
                                headers:
                                {
                                    'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                                    'x-requestId': uuid.v4(),
                                    'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
                                }
                            }
                        ).then(resp => {
                            // The communication was a success
                            resolve(resp)
                        }).catch(err => {
                            // Something happened
                            var error = err.response

                            switch (error.status) {
                                // we have to refresh the token
                                case 401:
                                    this.dispatch('refreshToken', params)
                                        .then(() => {
                                            // Token refresh was a success, resend last request
                                            this.dispatch('communicate', params)
                                                .then(resp => {
                                                    resolve(resp)
                                                })
                                                .catch(error => {
                                                    reject(error)
                                                })
                                        })
                                        .catch(() => {
                                            // Token refresh failed, send back to the login
                                            this.dispatch('logout')
                                                .then(() => {
                                                    history.go(0)
                                                })
                                        })
                                    break

                                // basic error in the request
                                case 400:
                                case 405:
                                case 422:
                                case 403:
                                case 500:
                                    reject(error)
                                    break
                                case 404:
                                    reject({
                                        'message': 'Nincs ilyen url',
                                        'error': true
                                    })
                                    break
                                case 429:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                                // Token refresh failed (probably), send back to the login
                                default:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                            }
                        })

                        break

                    case 'POST':
                        axios.post(
                            process.env.VUE_APP_ENDPOINT_URL + params.url,
                            params.axios_params.data,
                            {
                                headers: {
                                    'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                                    'x-requestId': uuid.v4(),
                                    'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
                                }
                            }
                        ).then(resp => {
                            // The communication was a success
                            resolve(resp)
                        }).catch(err => {
                            // Something happened
                            var error = err.response

                            switch (error.status) {
                                // we have to refresh the token
                                case 401:
                                    this.dispatch('refreshToken', params)
                                        .then(() => {
                                            // Token refresh was a success, resend last request
                                            this.dispatch('communicate', params)
                                                .then(resp => {
                                                    resolve(resp)
                                                })
                                                .catch(error => {
                                                    reject(error)
                                                })
                                        })
                                        .catch(() => {
                                            // Token refresh failed, send back to the login
                                            this.dispatch('logout')
                                                .then(() => {
                                                    history.go(0)
                                                })
                                        })
                                    break

                                // basic error in the request
                                case 400:
                                case 405:
                                case 422:
                                case 403:
                                case 500:
                                    reject(error)
                                    break
                                case 404:
                                    reject({
                                        'message': 'Nincs ilyen url',
                                        'error': true
                                    })
                                    break
                                case 429:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                                // Token refresh failed (probably), send back to the login
                                default:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                            }
                        })
                        break

                    case 'PUT':
                        axios.put(
                            process.env.VUE_APP_ENDPOINT_URL + params.url,
                            params.axios_params.data,
                            {
                                headers: {
                                    'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                                    'x-requestId': uuid.v4(),
                                    'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
                                }
                            }
                        ).then(resp => {
                            // The communication was a success
                            resolve(resp)
                        }).catch(err => {
                            // Something happened
                            var error = err.response

                            switch (error.status) {
                                // we have to refresh the token
                                case 401:
                                    this.dispatch('refreshToken', params)
                                        .then(() => {
                                            // Token refresh was a success, resend last request
                                            this.dispatch('communicate', params)
                                                .then(resp => {
                                                    resolve(resp)
                                                })
                                                .catch(error => {
                                                    reject(error)
                                                })
                                        })
                                        .catch(() => {
                                            // Token refresh failed, send back to the login
                                            this.dispatch('logout')
                                                .then(() => {
                                                    history.go(0)
                                                })
                                        })
                                    break

                                // basic error in the request
                                case 400:
                                case 405:
                                case 422:
                                case 403:
                                case 500:
                                    reject(error)
                                    break
                                case 404:
                                    reject({
                                        'message': 'Nincs ilyen url',
                                        'error': true
                                    })
                                    break
                                case 429:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                                // Token refresh failed (probably), send back to the login
                                default:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                            }
                        })
                        break

                    case 'DELETE':
                        axios.delete(
                            process.env.VUE_APP_ENDPOINT_URL + params.url,
                            {
                                data: {},
                                headers: {
                                    'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                                    'x-requestId': uuid.v4(),
                                    'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
                                },
                            }
                        ).then(resp => {
                            // The communication was a success
                            resolve(resp)
                        }).catch(err => {
                            // Something happened
                            var error = err.response

                            switch (error.status) {
                                // we have to refresh the token
                                case 401:
                                    this.dispatch('refreshToken', params)
                                        .then(() => {
                                            // Token refresh was a success, resend last request
                                            this.dispatch('communicate', params)
                                                .then(resp => {
                                                    resolve(resp)
                                                })
                                                .catch(error => {
                                                    reject(error)
                                                })
                                        })
                                        .catch(() => {
                                            // Token refresh failed, send back to the login
                                            this.dispatch('logout')
                                                .then(() => {
                                                    history.go(0)
                                                })
                                        })
                                    break

                                // basic error in the request
                                case 400:
                                case 405:
                                case 422:
                                case 403:
                                case 500:
                                    reject(error)
                                    break
                                case 404:
                                    reject({
                                        'message': 'Nincs ilyen url',
                                        'error': true
                                    })
                                    break
                                case 429:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                                // Token refresh failed (probably), send back to the login
                                default:
                                    this.dispatch('logout')
                                        .then(() => {
                                            history.go(0)
                                        })
                                    break
                            }
                        })
                        break

                    default:
                        reject({
                            'success': false,
                            'error': 'Invalid method'
                        })
                }
            })
        },
        refreshToken() {
            return new Promise((resolve, reject) => {
                this.dispatch(
                    'login',
                    {
                        "grant_type": "refresh_token",
                        "client_id": process.env.VUE_APP_CLIENT_ID,
                        "client_secret": process.env.VUE_APP_CLIENT_SECRET,
                        "scope": "*",
                        "refresh_token": localStorage.getItem('refreshToken')
                    }
                )
                    .then(response => {
                        // we couldnt refresh so now log them out
                        if (response.status != 200) {
                            reject()
                        } else {
                            // lets try again with the previous request now
                            resolve()
                        }
                    })
                    .catch(() => {
                        this.dispatch('logout')
                            .then(() => {
                                reject()
                            })
                            .catch(() => {
                                reject()
                            })
                    })
            })
        },
        getCities({ commit }) {
            return new Promise((resolve, reject) => {

                axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ENDPOINT_URL + 'api/cities?status=I',
                    headers: {
                        'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                        'x-requestId': uuid.v4(),
                    }
                })
                    .then(response => {
                        if (response.status == 200) {

                            let respData = JSON.stringify(response.data)

                            localStorage.setItem('cities', respData)
                            commit('set_cities', { respData })

                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })

            })
        },
        // eslint-disable-next-line no-unused-vars
        getHomeImages({ commit }, params) {
            return new Promise((resolve, reject) => {

                let suffix = ''
                if (params != null) {
                    suffix = `/${params}`
                }

                axios({
                    method: 'GET',
                    url: `${process.env.VUE_APP_ENDPOINT_URL}api/home-screen${suffix}`,
                    headers: {
                        'X-APP-ID': process.env.VUE_APP_X_API_KEY,
                        'x-requestId': uuid.v4(),
                    }
                })
                    .then(response => {
                        if (response.status == 200) {

                            resolve(response)
                        } else {
                            reject()
                        }
                    })
                    .catch((err) => {
                        reject(err)
                    })

            })
        }
    },
    getters: {
        isLoggedIn: state => !!state.accessToken,
        userData: (state) => {
            if (state.userData != '') {
                return JSON.parse(state.userData)
            } else {
                return {}
            }
        },
        cityModules: (state) => {
            if (state.cityModules != '') {
                return JSON.parse(state.cityModules)
            } else {
                return {}
            }
        },
        cities: state => {
            return JSON.parse(state.cities)
        },
        selectedCity: state => function (cityName) {

            let selectedCity = false


            // check if the given city name is in the userEnv if the user is logged in
            if (state.cities != '') {

                let cities = JSON.parse(state.cities)

                Object.entries(cities).forEach(
                    // eslint-disable-next-line no-unused-vars
                    ([index, city]) => {

                        if (state.accessToken == '') {
                            if (city.slub == cityName) {
                                selectedCity = {
                                    'name': city.name,
                                    'id': city.id,
                                    'slub': city.slub,
                                }
                            }

                        } else {
                            let cityId = JSON.parse(state.userData).city_id
                            if (cityId == city.id) {
                                selectedCity = {
                                    'name': city.name,
                                    'id': city.id,
                                    'slub': city.slub,
                                }
                            }
                        }
                    }
                )
            }

            return selectedCity
        }
    }
})
